import { LOCALE_ID, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppLayoutModule } from '../layouts/app.layout.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CaaksAuthModule } from '../auth/caaks-auth.module';
import { LoggerModule } from 'ngx-logger';
import { LoggerService } from './services/logger.service';
import { EffectsModule } from '@ngrx/effects';
import { appReducers } from './store/reducers/app.reducers';

registerLocaleData(localeFr);

@NgModule({
  declarations: [],
  exports: [CaaksAuthModule],
  imports: [
    CommonModule,
    AppLayoutModule,
    CaaksAuthModule,
    StoreModule.forRoot(appReducers),
    EffectsModule.forRoot([]),
    LoggerModule.forRoot(LoggerService.GetLoggerConfig()),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: false,
    }),
  ],
  providers: [
    DatePipe,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: RefreshTokenInterceptor,
    //   multi: true,
    // },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule a déja été chargé. Vous ne devez importer les modules Core que dans AppModule',
      );
    }
  }
}
